import Hero from'~/components/Hero';import HtmlParser from'~/components/HtmlParser/HtmlParser';import Layout from'~/components/Layout';import SectionWithTitle from'~/components/SectionWithTitle';import SEO from'~/components/SEO';import{getCurrentOrigin}from'~/utils/getCurrentDomain';import{getSeoDataFromWordpressForPage}from'~/utils/getSeoData';import{createImageWithArtDirection}from'~/utils/imageUtils';import JotFormReact from'jotform-react';import React from'react';export var validationPatternByType={checkbox:undefined,email:{message:"Ce format n'est pas celui d'un email valide",value:/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i},password:undefined,text:undefined,textArea:undefined};// const createValidationSchema = (questions: object) => {
//   return Object.keys(questions).reduce((schema, questionKey) => {
//     // @ts-ignore
//     const question = questions[questionKey];
//     let questionConfig;
//     switch (question.name) {
//       case 'upload':
//         questionConfig = yup
//           .mixed()
//           .test('fileSize', 'Le fichier est trop gros, il doit faire moins de 5Mo', (value: FileList) => {
//             return value[0] ? value[0].size <= 5000000 : true;
//           })
//           .test('type', 'Le fichier doit être au format PDF, PNG ou JPG/JPEG', (value: FileList) => {
//             return value[0]
//               ? value[0].type === 'image/jpeg' || value[0].type === 'image/png' || value[0].type === 'application/pdf'
//               : true;
//           });
//         break;
//       case 'birthdate':
//       case 'from_date':
//       case 'to_date':
//         questionConfig = yup
//           .string()
//           .trim()
//           .notOneOf(['', false], 'Champ requis')
//           .matches(
//             /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/,
//             "La date n'est pas au format jj/mm/yyyy"
//           );
//         break;
//       default:
//         questionConfig = question.required ? yup.mixed().notOneOf(['', false], 'Champ requis') : undefined;
//         break;
//     }
//     const questionName = question.type === 'radio' ? 'radio-' + question.name : question.name;
//     return {
//       ...schema,
//       [questionName]: questionConfig,
//     };
//   }, {});
// };
// type FormData = {
//   [key: string]: string | number | undefined;
// } & { upload: FileList | undefined };
var PageInscriptionTemplate=function PageInscriptionTemplate(props){var _contentTypeData$lang,_contentTypeData$lang2,_acfData$hero,_acfData$hero2,_acfData$hero3;// const [showSuccess, setShowSuccess] = useState(false);
// const [showError, setShowError] = useState(false);
var data=props.data;var pageContext=props.pageContext;var contentTypeData=data.wpPage;var acfData=contentTypeData===null||contentTypeData===void 0?void 0:contentTypeData.acfInscription;if(!contentTypeData||!acfData||!(contentTypeData!==null&&contentTypeData!==void 0&&contentTypeData.link)||!((_contentTypeData$lang=contentTypeData.language)!==null&&_contentTypeData$lang!==void 0&&_contentTypeData$lang.slug)||!pageContext.defaultLanguage)return null;var seoProps=getSeoDataFromWordpressForPage({availableTranslations:contentTypeData.translations,currentLanguage:(_contentTypeData$lang2=contentTypeData.language)===null||_contentTypeData$lang2===void 0?void 0:_contentTypeData$lang2.locale,currentOrigin:getCurrentOrigin(),defaultLanguage:pageContext.defaultLanguage,featuredImageUrl:'',pagePath:props.location.pathname,pageSlug:contentTypeData.slug,seo:contentTypeData.seo});var imageWithArtDirection=createImageWithArtDirection({desktopImage:(_acfData$hero=acfData.hero)===null||_acfData$hero===void 0?void 0:_acfData$hero.desktopFeaturedImage,mobileImage:(_acfData$hero2=acfData.hero)===null||_acfData$hero2===void 0?void 0:_acfData$hero2.mobileFeaturedImage});// const allQuestions = {
//   ...acfData.personalInfosQuestions,
//   ...acfData.bookingQuestions,
// };
// const allQuestionsKeysSortedByOrder = Object.keys(allQuestions).reduce<{
//   [key: string]: { order: number };
// }>((acc, questionKey) => {
//   const question = allQuestions[questionKey as keyof typeof allQuestions];
//   if (!question?.name || !question.order) return acc;
//   return {
//     ...acc,
//     [question.name]: { order: question.order },
//   };
// }, {});
// if (!allQuestions) return null;
// const validationSchemaConfig = createValidationSchema(allQuestions);
// const validationSchema = yup.object().shape(validationSchemaConfig);
// const { watch, register, handleSubmit, errors, formState } = useForm<FormData>({ validationSchema });
// const sortedPersonalInfosQuestions = Object.keys(acfData.personalInfosQuestions ?? {})
//   .sort(
//     // @ts-ignore
//     (a, b) => allQuestions?.[a]?.order - allQuestions?.[b]?.order
//   )
//   // @ts-ignore
//   .map((personalInfoQuestionKey) => allQuestions[personalInfoQuestionKey]);
// const sortedBookingQuestions = Object.keys(acfData.bookingQuestions ?? {})
//   .sort(
//     // @ts-ignore
//     (a, b) => allQuestions?.[a]?.order - allQuestions?.[b]?.order
//   )
//   // @ts-ignore
//   .map((bookingQuestionKey) => allQuestions[bookingQuestionKey]);
// const serializedPersonalInfosQuestions = serializeQuestions(sortedPersonalInfosQuestions);
// const sortedBookingQuestionsWithOptions = sortedBookingQuestions?.map((question) => {
//   switch (question.name) {
//     case 'program':
//       return {
//         ...question,
//         options: data.allWpFormule.nodes.map((node) => ({ label: node.title, name: node.slug })),
//       };
//     case 'destination_country':
//       return {
//         ...question,
//         options: data.allWpDestination.nodes.map((node) => ({ label: node.title, name: node.slug })),
//       };
//     default:
//       return question;
//   }
// });
// const serializedBookingQuestions = serializeQuestions(sortedBookingQuestionsWithOptions);
// const questionsByName = [...serializedPersonalInfosQuestions, ...serializedBookingQuestions].reduce(
//   (acc, question) => {
//     return {
//       ...acc,
//       [question.name]: question,
//     };
//   },
//   {}
// );
// const questionsToWatch = compact(
//   [...serializedPersonalInfosQuestions, ...serializedBookingQuestions].map(
//     (question) => question.displayCondition?.name
//   )
// );
// const onSubmit = async (formData: FormData) => {
//   setShowError(false);
//   const formDataSortedByQuestionOrder = Object.entries(formData).sort((a, b) => {
//     return allQuestionsKeysSortedByOrder[a[0]]?.order - allQuestionsKeysSortedByOrder[b[0]]?.order;
//   });
//   const formDataSortedByQuestionOrderWithFormattedValue: [string, string | number | undefined | object][] =
//     formDataSortedByQuestionOrder.map(([questionName, questionValue]) => {
//       const questionLabelAndOptions = questionsByName[questionName as keyof typeof questionsByName];
//       if (questionLabelAndOptions?.options?.length) {
//         const formattedOption =
//           questionLabelAndOptions?.options?.find((option) => option.name === questionValue)?.label ?? '';
//         return [questionName, formattedOption];
//       }
//       return [questionName, questionValue];
//     });
//   const encodedAuthorization = btoa(
//     `${process.env.GATSBY_WORDPRESS_API_LOGIN}:${process.env.GATSBY_WORDPRESS_API_PASSWORD}`
//   );
//   const response = formData?.['upload']?.[0]
//     ? await fetch(process.env.GATSBY_UPLOAD_ENDPOINT, {
//         body: formData['upload'][0],
//         headers: {
//           Authorization: `Basic ${encodedAuthorization}`,
//           'Content-Disposition': `attachment; filename="${formData['upload'][0].name}"`,
//           'Content-Type': formData['upload'][0].type,
//         },
//         method: 'POST',
//       })
//     : null;
//   const responseData = await response?.json();
//   const sourceUrl = responseData?.source_url ?? 'Pas de fichier';
//   const encode = (formDataToEncode: [string, string | number | undefined | object][]) => {
//     return formDataToEncode
//       .map(
//         // @ts-ignore
//         ([key, value]) => {
//           const questionKeyWithoutRadio = key.replace('radio-', '');
//           // @ts-ignore
//           const displayedKey =
//             key === 'upload'
//               ? 'Fichier'
//               : `${questionsByName[questionKeyWithoutRadio as keyof typeof questionsByName].label} :`;
//           let displayedValue;
//           if (key === 'upload') {
//             displayedValue = sourceUrl;
//           } else if (typeof value === 'boolean') {
//             displayedValue = value ? 'oui' : 'non';
//           } else {
//             displayedValue = value;
//           }
//           return renderToStaticMarkup(
//             <p>
//               <strong>{removeHtmlTags(displayedKey)}</strong> {removeHtmlTags(displayedValue)}
//             </p>
//           );
//         }
//       )
//       .join('');
//   };
//   const encodedData = encode(formDataSortedByQuestionOrderWithFormattedValue);
//   const userEmail = formDataSortedByQuestionOrderWithFormattedValue.find(
//     (questionKey, _) => questionKey[0] === 'email'
//   )?.[1];
//   if (process.env.GATSBY_MAIL_ENDPOINT) {
//     fetch(process.env.GATSBY_MAIL_ENDPOINT, {
//       body: JSON.stringify({
//         content: encodedData,
//         userEmail,
//       }),
//       headers: { 'Content-Type': 'application/raw' },
//       method: 'POST',
//     })
//       .then(() => setShowSuccess(true))
//       .catch(() => setShowError(true));
//   } else {
//     setShowError(true);
//   }
// };
return/*#__PURE__*/React.createElement(Layout,{currentLanguage:contentTypeData.language,currentPath:contentTypeData.link,menuData:pageContext.menus,siteSettings:pageContext.siteSettings,translations:contentTypeData.translations},/*#__PURE__*/React.createElement(SEO,seoProps),/*#__PURE__*/React.createElement(Hero,{backgroundImage:imageWithArtDirection,couleurTitre:"#000",heading:(_acfData$hero3=acfData.hero)===null||_acfData$hero3===void 0?void 0:_acfData$hero3.title,size:"short"}),/*#__PURE__*/React.createElement(SectionWithTitle,{maxW:"500px"},/*#__PURE__*/React.createElement(HtmlParser,{textBlock:true,textAlign:"left"},acfData.explanations),/*#__PURE__*/React.createElement(JotFormReact,{formURL:"https://form.jotform.com/241063173478356"})));};export default PageInscriptionTemplate;var query="2856323559";